import React from 'react';
import DashboardLayout from '../../components/common/DashboardLayout';
import PageHeading from '../../components/common/PageHeading';

// Jenn's Google Calendar appointment schedule "Booked Calls" (2026-10-01) — replaces the
// GHL widget, whose link.365reset.com address stopped resolving. `gv=true` is Google's
// embed form of the booking page.
const BOOKING_URL = 'https://calendar.google.com/calendar/appointments/schedules/AcZssZ1SRBlxqd4YS9Z7P2I8JULVi9kDi37KXZemQs_fFjedLypZvgekWIeoYxx-IEX7VA767sa85c9Y?gv=true';

/**
 * Embeds the booking page in-app instead of opening a new tab —
 * Jenn, 2026-08-27: "can the Book a Call with Jenn not go to a new browser
 * page, but rather be accessed within a page in the system? I want to
 * keep them in the site." Needs calendar.google.com allowed in the CSP's
 * frameSrc (server/src/app.js) or the iframe silently fails to load.
 */
export default function BookCall() {
  return (
    <DashboardLayout>
      <div className="max-w-5xl mx-auto">
        <div className="mb-6">
          <PageHeading title="Book 30 minutes with Jenn" />
        </div>
        <div className="bg-white rounded-2xl shadow-sm overflow-hidden" style={{ height: '80vh', minHeight: 640 }}>
          <iframe
            src={BOOKING_URL}
            title="Book a Call with Jenn"
            className="w-full h-full border-0"
          />
        </div>
      </div>
    </DashboardLayout>
  );
}
